$(document).ready(function() {
    $('.inspiration-slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});

// $(document).ready(function() {
//     $('.uber-uns-slider').slick({
//         dots: false,
//         infinite: false,
//         speed: 300,
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         responsive: [{
//                 breakpoint: 800,
//                 settings: {
//                     slidesToShow: 3,
//                     slidesToScroll: 1
//                 }
//             },
//             {
//                 breakpoint: 600,
//                 settings: {
//                     slidesToShow: 2,
//                     slidesToScroll: 1
//                 }
//             },
//             {
//                 breakpoint: 480,
//                 settings: {
//                     slidesToShow: 1,
//                     slidesToScroll: 1
//                 }
//             }
//         ]
//     });
// });
//     $(function() {
//         $(document).click(function() {
//             $('.header.site-header .site-nav__icons a.site-nav__link.site-nav__link--icon.js-search-header').removeClass('hide-icon-class'); //hide the button
//             console.log('clicked');

//         });
//     });
//     $('header.site-header .site-nav__icons a.site-nav__link.site-nav__link--icon.js-search-header').on('click', function() {
//         if ($('.site-header__search-container').hasClass('is-active')) {
//             $('header.site-header .site-nav__icons a.site-nav__link.site-nav__link--icon.js-search-header').addClass('hide-icon-class');
//         } else {
//             $('header.site-header .site-nav__icons a.site-nav__link.site-nav__link--icon.js-search-header').removeClass('hide-icon-class');
//         }

//     });

//     $('button.js-search-header-close.text-link.site-header__search-btn').on('click', function() {
//         if ($('header.site-header .site-nav__icons a.site-nav__link.site-nav__link--icon.js-search-header').hasClass('hide-icon-class')) {
//             $('header.site-header .site-nav__icons a.site-nav__link.site-nav__link--icon.js-search-header').removeClass('hide-icon-class');
//         }
//     })
//     $('button.text-link.site-header__search-btn').on('click', function() {
//         if ($('header.site-header .site-nav__icons a.site-nav__link.site-nav__link--icon.js-search-header').hasClass('hide-icon-class')) {
//             $('header.site-header .site-nav__icons a.site-nav__link.site-nav__link--icon.js-search-header').removeClass('hide-icon-class');
//         }
//     })
// });


$(document).ready(function() {
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.uber-uns-slider',
        autoplay: false
    });
    $('.uber-uns-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        focusOnSelect: true,
        infinite: true,
        centerPadding: '0px',
        responsive: [{
                breakpoint: 800,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
});



$(document).ready(function() {
    $('.collection-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        responsive: [{
                breakpoint: 800,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
});